module.exports = __webpack_public_path__ + "static/media/news_bg02.cf7b96f2.jpg";